import {
    GridRowSelectionModel,
} from '@mui/x-data-grid-pro'

export const DEFAULT_MAIN_TABLE_IN_DETAILS_VIEW_WIDTH_PERCENT = 20
export const PAGE_SIZE_OPTIONS = []
export const PAGE_SIZE_DEFAULT = 25
export const DELAY_TIMEOUT = 600
export const HEADER_HEIGHT = 52
export const ROW_HEIGHT = 36

export const INIT_SELECTION_MODEL: GridRowSelectionModel = {
    type: 'include',
    ids: new Set<number>(),
}
